import React from 'react';
import Loadable from 'react-loadable';

import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';

let Component = false;

if (process.env.RUNTIME_ENV !== 'browser') {
  // eslint-disable-next-line global-require
  Component = require('../sponsored_kia_tag_page').default;
}

export default function(store) {
  const routeConfig = {
    path: '/section/living-smarter',
    component() {
      if (Component) {
        return <Component />;
      }

      return <LazyComponent />;
    },
    exact: true,
    strict: true,
    loadData: Component ? Component.loadData(store, 'living-smarter') : false,
    preloadChunk() {
      return import(/* webpackChunkName: "sponsoredKiaTagCustomPage" */ '../sponsored_kia_tag_page').then(
        resp => {
          Component = resp.default;
          routeConfig.loadData = Component.loadData(store, 'living-smarter');
          return Component;
        }
      );
    },
    chunk: 'sponsoredKiaTagCustomPage'
  };

  const LazyComponent = Loadable({
    loader() {
      return routeConfig.preloadChunk();
    },
    loading() {
      return (
        <section className="search">
          <LoadingSpinner />
        </section>
      );
    }
  });

  return routeConfig;
}
